import React, { Component } from 'react';
import styled from 'styled-components';

import { ContentSection, PageHeader } from './components';
import RegisterUserFormContainer from '../user/components/RegisterUserFormContainer';

const StyledPage = styled.div`
	> header {
		text-align: center;
    margin-top: 3rem;
	}
`;

class RegistrationPage extends Component {

  render() {
    return (
      <StyledPage>
        <PageHeader title="Tervetuloa C More Sisäpiiriin!" />
        <ContentSection>
          <RegisterUserFormContainer />
        </ContentSection>
      </StyledPage>
    );
  }
};

export default RegistrationPage;


// WEBPACK FOOTER //
// ./src/modules/pages/RegistrationPage.js